var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { inject, observer } from 'mobx-react';
import { Stack, TextField, FormControl, InputAdornment, Divider, Button } from '@mui/material';
import validator from 'validator';
import { EditorState, convertToRaw, ContentState, Modifier } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { LinkOption } from '../case-types/controls/link-option-ctrl';
import EmailIcon from '@mui/icons-material/Email';
import '../styles/css/react-draft.css';
var EmailTemplateEditor = /** @class */ (function (_super) {
    __extends(EmailTemplateEditor, _super);
    function EmailTemplateEditor(props) {
        var _a, _b, _c, _d, _e, _f;
        var _this = _super.call(this, props) || this;
        var templateEditorState = EditorState.createEmpty();
        var emailReplyTo = (_b = (_a = props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType) === null || _b === void 0 ? void 0 : _b.emailSenderLink;
        var emailHtml = (_d = (_c = props.caseTypesStore) === null || _c === void 0 ? void 0 : _c.currentCaseType) === null || _d === void 0 ? void 0 : _d.emailTemplate;
        if (typeof emailHtml != 'undefined' && emailHtml) {
            var contentDraftBlock = htmlToDraft(emailHtml);
            if (contentDraftBlock) {
                var contentState = ContentState.createFromBlockArray(contentDraftBlock.contentBlocks);
                templateEditorState = EditorState.createWithContent(contentState);
            }
        }
        _this.state = {
            emailTemplateEditorState: templateEditorState,
            emailSubject: (_f = (_e = props.caseTypesStore) === null || _e === void 0 ? void 0 : _e.currentCaseType) === null || _f === void 0 ? void 0 : _f.emailSubject,
            emailSenderLink: emailReplyTo,
            isValidReplyLink: true,
            errorTextLinkField: "",
            isExistsLinkPattern: true,
            errorTextLinkPattern: ""
        };
        return _this;
    }
    Object.defineProperty(EmailTemplateEditor.prototype, "getPageLanguage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var language = document.documentElement.lang;
            if (!language)
                language = 'en';
            return language;
        }
    });
    Object.defineProperty(EmailTemplateEditor.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b, _c, _d, _e;
            var emailTemplateEditorState = this.state.emailTemplateEditorState;
            var language = this.getPageLanguage();
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            return (_jsxs(Stack, __assign({ direction: "column", spacing: 2, className: "case-types-tab-panel" }, { children: [_jsx(Divider, {}, void 0), _jsxs("h4", { children: [_jsx(EmailIcon, {}, void 0), " ", (_b = this.props.languageStore) === null || _b === void 0 ? void 0 : _b.getLabel('Settings.Ticket.EmailTemplate.Header'), _jsx(Button, __assign({ sx: { marginLeft: '15px' }, variant: "outlined", onClick: function () { return _this.onInsertLinkClick(); } }, { children: (_c = this.props.languageStore) === null || _c === void 0 ? void 0 : _c.getLabel('Settings.Ticket.SmsTemplate.Field.AppendLinkButton') }), void 0)] }, void 0), _jsxs(Stack, __assign({ direction: "row", spacing: 2 }, { children: [_jsx(FormControl, __assign({ fullWidth: true, variant: "outlined" }, { children: _jsx(TextField, { fullWidth: true, label: (_d = this.props.languageStore) === null || _d === void 0 ? void 0 : _d.getLabel('Settings.Ticket.EmailTemplate.ReplyTo'), value: caseType === null || caseType === void 0 ? void 0 : caseType.emailSenderLink, onChange: function (e) { return _this.onLinkValueChanged(e); }, error: !this.state.isValidReplyLink, helperText: this.state.errorTextLinkField, InputProps: {
                                        endAdornment: _jsx(InputAdornment, __assign({ position: "end" }, { children: "@youcit.at" }), void 0),
                                    } }, void 0) }), void 0), _jsx(TextField, { variant: "outlined", fullWidth: true, onChange: function (e) { return _this.onSubmitValueChanged(e); }, value: caseType === null || caseType === void 0 ? void 0 : caseType.emailSubject, label: (_e = this.props.languageStore) === null || _e === void 0 ? void 0 : _e.getLabel('Settings.Ticket.EmailTemplate.Field.Subject') }, void 0)] }), void 0), _jsx(Editor, { editorState: emailTemplateEditorState, wrapperClassName: "text-editor-wrapper", editorClassName: "text-editor", toolbar: {
                            options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'history', 'image', 'link'],
                            inline: { inDropdown: true },
                            list: { inDropdown: true },
                            textAlign: { inDropdown: true },
                            link: {
                                inDropdown: false,
                                showOpenOptionOnHover: true,
                                defaultTargetOption: '_blank',
                                options: ['link', 'unlink']
                            },
                            history: { inDropdown: true },
                            image: {
                                urlEnabled: true,
                                uploadEnabled: true,
                                alignmentEnabled: true,
                                uploadCallback: undefined,
                                previewImage: false,
                                inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                                alt: { present: false, mandatory: false },
                                defaultSize: {
                                    height: 'auto',
                                    width: 'auto',
                                },
                                tEnabled: true,
                            }
                        }, toolbarCustomButtons: [_jsx(LinkOption, { editorState: emailTemplateEditorState, onChange: function () { return _this.onEditorStateChange(emailTemplateEditorState); } }, void 0)], localization: {
                            locale: language
                        }, onEditorStateChange: function (state) { return _this.onEditorStateChange(state); } }, void 0)] }), void 0));
        }
    });
    Object.defineProperty(EmailTemplateEditor.prototype, "onEditorStateChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (emailEditorState) {
            var _a, _b;
            this.setState({
                emailTemplateEditorState: emailEditorState
            });
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            var templateHtml = draftToHtml(convertToRaw(emailEditorState.getCurrentContent()));
            if (caseType) {
                var updatedCaseType = __assign(__assign({}, caseType), { emailTemplate: templateHtml });
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
            }
        }
    });
    Object.defineProperty(EmailTemplateEditor.prototype, "onLinkValueChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b, _c, _d;
            var isValid = true;
            var errorFieldText = "";
            var inputValue = e.target.value;
            if (inputValue.length > 0) {
                inputValue += "@youcit.at";
                isValid = validator.isEmail(inputValue);
                if (isValid === false) {
                    var strText = (_a = this.props.languageStore) === null || _a === void 0 ? void 0 : _a.getLabel('Settings.Ticket.EmailTemplate.Error.EmailNotValid');
                    errorFieldText = strText !== null && strText !== void 0 ? strText : "Email address is not valid";
                }
            }
            if (isValid) {
                errorFieldText = "";
            }
            this.setState({
                isValidReplyLink: isValid,
                errorTextLinkField: errorFieldText
            });
            var caseType = (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.currentCaseType;
            if (caseType) {
                var updatedCaseType = __assign(__assign({}, caseType), { emailSenderLink: e.target.value });
                (_c = this.props.caseTypesStore) === null || _c === void 0 ? void 0 : _c.updateCaseType(updatedCaseType);
                (_d = this.props.caseTypesStore) === null || _d === void 0 ? void 0 : _d.setValidField(isValid);
            }
        }
    });
    Object.defineProperty(EmailTemplateEditor.prototype, "onSubmitValueChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (caseType) {
                var updatedCaseType = __assign(__assign({}, caseType), { emailSubject: e.target.value });
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
            }
        }
    });
    Object.defineProperty(EmailTemplateEditor.prototype, "onInsertLinkClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var editorState = this.state.emailTemplateEditorState;
            var selection = editorState.getSelection();
            var contentState = editorState.getCurrentContent();
            var ncs = Modifier.insertText(contentState, selection, "{link}");
            var newEditorState = EditorState.push(editorState, ncs, 'insert-fragment');
            this.setState(__assign(__assign({}, this.state), { emailTemplateEditorState: newEditorState }));
        }
    });
    EmailTemplateEditor = __decorate([
        inject('caseTypesStore'),
        inject('languageStore'),
        observer
    ], EmailTemplateEditor);
    return EmailTemplateEditor;
}(React.Component));
export default EmailTemplateEditor;
